<template>
	<div class="msg-details-container">
		<div class="breadcrumb">
			<router-link :to="{ path: '/painter-msg-center', query: { category: 1 } }"
				class="breadcrumb-item">消息中心</router-link>
			<span class="breadcrumb-separator">></span>
			<span class="breadcrumb-item current">平台公告</span>
		</div>
		<div class="content-container">
			<div class="detailsBox">
				<div class="title">
					{{details.title ? details.title : ''}}
				</div>
				<div class="time">
					{{details.create_time ? details.create_time : ''}}
				</div>
				<div class="msgContent" v-html="details.content ? details.content : ''">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MsgDetails',
		data() {
			return {
				details: {}
			}
		},
		mounted() {
			this.gonggaoDetails()
		},
		methods: {
			gonggaoDetails() {
				this.$api.post('/Other/gonggao_details', {
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data
						this.details.content = this.formatRichText(this.details.content)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					match = match.replace(/style=""/gi, '').replace(/style=''/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match) {
					match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
						'width:100%;');
					return match;
				});
				newContent = newContent.replace(/<img/gi,
					'<img style="width:100%;height:auto;display:block;margin:0px 0;"');

				return newContent;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.msg-details-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		border-radius: .08rem;
		background: #FFFFFF;
		height: calc(100vh - 3.66rem);
	}

	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.content-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
		height: calc(100vh - 4.42rem);
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		margin-left: .3rem;
		margin-bottom: .24rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.detailsBox {
		padding: 0 .4rem .32rem;
		border-radius: .08rem;

		.title {
			font-weight: 500;
			font-size: .24rem;
			color: #252525;
		}

		.time {
			margin-top: .08rem;
			margin-bottom: .2rem;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			line-height: .2rem;
			padding-bottom: .24rem;
			border-bottom: 0.01rem solid #CCCCCC;
		}

		.msgContent {
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
		}
	}
</style>